import { calcSizeUnattached } from '@tyler-components-web/core';
import { toggleClass } from '../core/utils';
import { FLOATING_LABEL_CONSTANTS } from './floating-label-constants';
var FloatingLabel = /** @class */ (function () {
    function FloatingLabel(_labelElement) {
        this._labelElement = _labelElement;
        this._labelElement.classList.add(FLOATING_LABEL_CONSTANTS.classes.FLOATING_LABEL);
    }
    FloatingLabel.prototype.destroy = function () {
        this._labelElement.classList.remove(FLOATING_LABEL_CONSTANTS.classes.FLOATING_LABEL);
    };
    /**
     * Sets the floating state of the label element.
     * @param float If true, sets the label to float, otherwise un-float.
     */
    FloatingLabel.prototype.float = function (float) {
        toggleClass(this._labelElement, float, FLOATING_LABEL_CONSTANTS.classes.FLOAT);
    };
    /** Returns the scroll width of the label element. */
    FloatingLabel.prototype.getWidth = function () {
        if (this._labelElement.offsetParent !== null) {
            return this._labelElement.scrollWidth;
        }
        return calcSizeUnattached(this._labelElement).width;
    };
    return FloatingLabel;
}());
export { FloatingLabel };
